import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningPathItemsBuilder(apiClient: AxiosInstance) {
  return async function getLearningPathItems(options: {
    slug: string;
    page?: number;
    size?: number;
  }): Promise<ILearning.LearningPathItem[] | null> {
    try {
      const response = await apiClient.get("/learning/api/paths/", {
        params: {
          ...options,
        },
      });
      return response.data;
    } catch {
      return null;
    }
  };
}
